"use client";

import { useLayoutEffect, useSyncExternalStore } from "react";

// De Navbar staat in de layout en weet op de server alleen de route. Een
// weergave zonder filmkop (foutscherm, niet gevonden) meldt zich hier, zodat de
// kopbalk wit blijft in plaats van doorzichtig boven een witte pagina.
// Standaard is er "wel een filmkop": server en eerste browserweergave blijven
// op de gewone dealpagina gelijk (geen flits).
let teller = 0;
const luisteraars = new Set();

function subscribe(fn) {
  luisteraars.add(fn);
  return () => luisteraars.delete(fn);
}
function wijzig(delta) {
  teller = Math.max(0, teller + delta);
  luisteraars.forEach((fn) => fn());
}

/** true zolang minstens één weergave zegt dat er geen filmkop onder de kopbalk staat. */
export function useGeenFilmKop() {
  return useSyncExternalStore(subscribe, () => teller > 0, () => false);
}

/** Reisfallbacks kunnen de witte kop ook vóór hydratatie via CSS inschakelen. */
export default function GeenFilmKop({ serverWitteKop = false }) {
  useLayoutEffect(() => {
    wijzig(1);
    return () => wijzig(-1);
  }, []);
  return serverWitteKop ? <span hidden data-filmkop-witte-kop="" /> : null;
}
